import { NgModule, DoBootstrap, LOCALE_ID } from '@angular/core';

import { CommonModule, registerLocaleData } from '@angular/common';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { LayoutModule } from './layout/layout.module';
import { FeaturesModule } from './features/features.module';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from './extensions/components/components.module';
import { ApiServicesModule } from './extensions/services/api/api-services.module';
import { ServicesModule } from './extensions/services/services.module';
import { TenantAPIService } from './extensions/services/api/tenant-api.service';
import { HttpLoaderFactory } from './core/i18n/translation-loader/translate-server.loader';
import { HttpClient } from '@angular/common/http';

import { StoreModule } from '@ngrx/store';
import { signalrReducer } from './core/reducers/message.reducer';

import '@progress/kendo-angular-intl/locales/ro/all';
import '@progress/kendo-angular-intl/locales/en/all';
import '@progress/kendo-angular-intl/locales/fr/all';
import '@progress/kendo-angular-intl/locales/de/all';
import '@progress/kendo-angular-intl/locales/bg/all';
import '@progress/kendo-angular-intl/locales/it/all';
import '@progress/kendo-angular-intl/locales/es/all';
import '@progress/kendo-angular-intl/locales/pl/all';

import localeRo from '@angular/common/locales/ro';
import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';
import localeDe from '@angular/common/locales/de';
import localeBg from '@angular/common/locales/bg';
import localeIt from '@angular/common/locales/it';
import localeEs from '@angular/common/locales/es';
import localePl from '@angular/common/locales/pl';
import { EditorModule } from '@progress/kendo-angular-editor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

registerLocaleData(localeRo);
registerLocaleData(localeEn);
registerLocaleData(localeFr);
registerLocaleData(localeDe);
registerLocaleData(localeBg);
registerLocaleData(localeIt);
registerLocaleData(localeEs);
registerLocaleData(localePl);

@NgModule({
  declarations: [AppComponent],
  imports: [
    CommonModule,
    AppRoutingModule,
    CoreModule,
    FeaturesModule,
    LayoutModule,
    NgbModule,
    ComponentsModule,
    ServicesModule,
    ApiServicesModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [TenantAPIService, HttpClient],
      },
    }),
    StoreModule.forRoot({
      signalRState: signalrReducer,
    }),
    EditorModule,
    BrowserAnimationsModule,
  ],
  providers: [{ provide: LOCALE_ID, useValue: localStorage.getItem('selectedLanguage') }, NgbActiveModal],
  bootstrap: [AppComponent],
})
export class AppModule {}
